import { render, staticRenderFns } from "./OrderAddNote.vue?vue&type=template&id=4dc5de85"
import script from "./OrderAddNote.vue?vue&type=script&lang=js"
export * from "./OrderAddNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports